// extracted by css-extract-rspack-plugin
export default {"cls1":"ZeroState-cls1_lxe","cls2":"ZeroState-cls2_c9J ZeroState-cls1_lxe"};